import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { useNavigate } from "react-router";
import InfoHeader from "../../../../components/InfoHeader";
import Page from "../../../../components/Page";

export const NotFound = () => {
  const navigate = useNavigate();

  // Event handlers
  const handlePressHome = () => {
    navigate("/");
  };

  // Render
  return (
    <Page>
      <InfoHeader
        title={getLocalizedText("system.error.404")}
        largeButton={true}
        buttonTitle={getLocalizedText("system.back")}
        onPressButton={handlePressHome}
      />
    </Page>
  );
};
